import type { SVGProps } from 'react';
const SvgAirlineSeatIndividualSuite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#airline_seat_individual_suite_svg__a)">
      <path
        fill="currentColor"
        d="M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3Zm12-6h-8v7H3V7H1v10h22v-6c0-2.21-1.79-4-4-4Z"
      />
    </g>
    <defs>
      <clipPath id="airline_seat_individual_suite_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAirlineSeatIndividualSuite;
